export const CHAINS_CONSTS = {
	GET_CHAINS: "GET_CHAINS",
	GET_CHAIN: "GET_CHAIN",
	UPDATE_CHAINS: "UPDATE_CHAINS",
};